<template>
  <div style="background-color:#f9f9f9;">
    <div class="container footer">

      <div class="row align-items-center" v-if="(profile && profile.is_ldr)">
        <div class="col-sm-12 col-lg-8">
          <p><strong>Landscape Diagnostic &ndash; Enabling data-driven landscapes!</strong></p>
          <p>The Landscape Diagnostic service by <a href="https://mapworks.nl/">Mapworks</a> is a digital service that lets you keep track of what is happening in your landscapes, all based on open access geodata. Investigate land cover change, forest loss, or climate change. It is all just a click away.
          </p>
          <p>
          Contact us via <a href="mailto:support@mapworks.nl">support@mapworks.nl</a> for more questions, comments, and feedback.
          
          </p>

        </div>
        <div class="col-sm-12 col-lg-4 text-center">
          <a href="https://mapworks.nl/"><img src="../../assets/ldr-logo-with-title.png" class="img-fluid" style="height:60px;" /></a><br/>
              <template v-if="(profile && profile.is_ldr)">                
                <img src="../../assets/whitelabels/idh.png" style="height:50px;padding-top:0px;margin-top:5px;">
                <img src="../../assets/whitelabels/svi_sm.png" style="height:85px;margin-left:20px;margin-top:5px;" v-if="(profile && ((profile.username == 'svi') || (profile.username=='idh-madagascar')))">
              </template>
        </div>

      </div>


      <div class="row align-items-center" v-else>
        <div class="col-sm-12 col-lg-8">
          <p><strong>Geofolio makes environmental data accessible and understandable for everyone.</strong></p>
          <p>Get in touch via <a href="mailto:info@geofolio.org">info@geofolio.org</a> and <a href="https://twitter.com/geofolio">@geofolio</a> for questions, feedback, and collaboration. 
          

          </p>
          <p>
            You can <router-link :to="{ name: 'register' }">create an account</router-link> or <router-link :to="{ name: 'login' }">log in</router-link> if you want to help us test new features.
          </p>
          <p>
            <router-link to="/about">About</router-link> | 
            <router-link to="/frequently-asked-questions">Frequently Asked Questions</router-link> | 
            <router-link to="/example">Example Factsheet</router-link> | 
            <router-link to="/terms">Terms of Service</router-link> | 
            <router-link to="/privacy">Privacy</router-link>
          </p>

        </div>
        <div class="col-sm-12 col-lg-4 text-center">
          <p style="margin-bottom:8px;">Geofolio is created and maintained by:</p>
          <a href="https://mapworks.nl/"><img src="../../assets/mapworks-logo.svg" class="img-fluid" style="width:110px;" /></a>
        </div>

      </div>






    </div>


  </div>
</template>

<script>
  
  export default {
    name: 'footer',
    components: {
    },
    computed: {
        profile() {
            if(this.$store.state.profile) {
                return this.$store.state.profile
              } else {
                return this.$store.state.profile_pub;
              }
        }
    },
  }
</script>

<style>
    div.footer {
      padding-top:15px;
      color:#888;
      font-size:1.1em;
      background-color:#f5f5f5;
    }
</style>